import { useState, useEffect } from "react";

const getServiceHubData = () => {
  if (typeof window === "undefined") {
    return null; // Return null if running on the server side (SSR)
  }

  const serviceHubData = localStorage.getItem("serviceHub");

  if (!serviceHubData) {
    return null; // Return null if no data is found in localStorage
  }

  try {
    return JSON.parse(atob(serviceHubData)); // Decode and parse the data
  } catch (error) {
    console.error("Failed to parse serviceHub:", error);
    return null; // Return null if parsing fails
  }
};

// Main function to get the currency code
export const useCurrencyCode = () => {
  const [currencySymbol, setCurrencySymbol] = useState("₹"); // Default to ₹ (INR) during SSR

  useEffect(() => {
    const serviceHub = getServiceHubData();

    if (serviceHub && serviceHub?.countryCurrencyName) {
      const currencyCode = serviceHub.countryCurrencyName;

      // Manually handle NPR for Nepal to avoid errors during rendering
      if (currencyCode === "NPR") {
        setCurrencySymbol("NPR");
      } else {
        try {
          const currencySymbol = new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: currencyCode,
          }).format(0); // Format a value (e.g., 0) to get the symbol

          const symbol = currencySymbol.replace(/[0-9.,\s]/g, "").trim();
          setCurrencySymbol(symbol); // Set the currency symbol
        } catch (error) {
          console.error("Error fetching currency code", error);
          setCurrencySymbol("₹"); // Fallback to INR symbol
        }
      }
    } else {
      setCurrencySymbol("₹"); // Fallback if no serviceHub data
    }
  }, []); // Empty dependency array ensures this effect runs only once on the client side

  return currencySymbol; // Return the currency symbol
};
